import * as THREE from "three";
import { mapConfig } from "./mapConfig";
import { MapRuntime } from "./runtime";

export function bindMapInteractions(runtime: MapRuntime) {
  const raycaster = new THREE.Raycaster();
  const pointer = new THREE.Vector2();
  const mouseDownPos = { x: 0, y: 0 };

  const updatePointer = (e: MouseEvent) => {
    const rect = runtime.currentDom.getBoundingClientRect();
    pointer.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
    pointer.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
  };

  const pickProvince = (e: MouseEvent) => {
    updatePointer(e);
    raycaster.setFromCamera(pointer, runtime.camera);
    const intersects = raycaster.intersectObjects(runtime.scene.children, true);
    return intersects.find((item: any) => item.object.userData.isChangeColor);
  };

  const getProvinceProperties = (object: THREE.Object3D) => {
    let current: THREE.Object3D | null = object;
    while (current) {
      const properties = (current as any).customProperties;
      if (properties?.name) {
        return properties;
      }
      current = current.parent;
    }
    return null;
  };

  const onResizeEvent = () => {
    runtime.camera.aspect =
      runtime.currentDom.clientWidth / runtime.currentDom.clientHeight;
    runtime.camera.updateProjectionMatrix();
    runtime.renderer.setSize(
      runtime.currentDom.clientWidth,
      runtime.currentDom.clientHeight
    );
    runtime.labelRenderer.setSize(
      runtime.currentDom.clientWidth,
      runtime.currentDom.clientHeight
    );
    runtime.renderer.setPixelRatio(window.devicePixelRatio);
  };

  const onMouseMoveEvent = (e: MouseEvent) => {
    const target = pickProvince(e);

    if (runtime.lastPick) {
      const color = mapConfig.mapColorGradient[Math.floor(Math.random() * 4)];
      runtime.lastPick.object.material[0].color.set(color);
      runtime.lastPick.object.material[0].opacity = mapConfig.mapOpacity;
    }

    runtime.lastPick = target;

    if (runtime.lastPick?.object.material[0]) {
      runtime.lastPick.object.material[0].color.set(mapConfig.mapHoverColor);
      runtime.lastPick.object.material[0].opacity = 1;
    }
  };

  const onMouseDownEvent = (e: MouseEvent) => {
    mouseDownPos.x = e.clientX;
    mouseDownPos.y = e.clientY;
  };

  const onClickEvent = (e: MouseEvent) => {
    // 拖拽旋转时不触发下钻
    const dx = e.clientX - mouseDownPos.x;
    const dy = e.clientY - mouseDownPos.y;
    if (dx * dx + dy * dy > 25) {
      return;
    }

    const target = pickProvince(e);
    const properties = target ? getProvinceProperties(target.object) : null;
    if (!properties) {
      return;
    }

    // 乡镇单体为最末级，不可再下钻
    if (properties.level === "town") {
      return;
    }

    runtime.dblClickFn(properties);
  };

  window.addEventListener("resize", onResizeEvent, false);
  window.addEventListener("mousemove", onMouseMoveEvent, false);
  window.addEventListener("mousedown", onMouseDownEvent, false);
  window.addEventListener("click", onClickEvent, false);

  runtime.cleanupCallbacks.push(() => {
    window.removeEventListener("resize", onResizeEvent);
    window.removeEventListener("mousemove", onMouseMoveEvent);
    window.removeEventListener("mousedown", onMouseDownEvent);
    window.removeEventListener("click", onClickEvent);
  });

  return { raycaster, pointer };
}
